var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9024 8.01389C13.5124 8.31542 8.46982 13.5942 8.48907 19.9396C8.49496 21.8723 8.96536 23.6965 9.79526 25.3087L8.52125 31.4428C8.45238 31.7747 8.75407 32.0653 9.0864 31.9872L15.1461 30.5632C16.703 31.3325 18.4516 31.7767 20.3022 31.8047C26.8335 31.9037 32.2792 26.7598 32.483 20.2837C32.701 13.3417 26.9251 7.68205 19.9024 8.01389ZM27.133 26.4933C25.3585 28.2535 22.9988 29.223 20.489 29.223C19.0196 29.223 17.6125 28.8959 16.3071 28.251L15.4634 27.8339L11.7479 28.7069L12.5299 24.9413L12.1143 24.1336C11.4366 22.8172 11.0929 21.3939 11.0929 19.9028C11.0929 17.4132 12.0703 15.0728 13.8449 13.3124C15.6036 11.5677 18.0017 10.5827 20.4892 10.5827C22.9987 10.5827 25.3584 11.5522 27.133 13.3124C28.9075 15.0726 29.8849 17.4132 29.8849 19.9025C29.8851 22.37 28.8919 24.7487 27.133 26.4933Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.3127 22.4847L23.9882 21.8228C23.6828 21.7359 23.3536 21.8219 23.1309 22.047L22.5624 22.6213C22.3228 22.8637 21.9592 22.9414 21.642 22.8141C20.5424 22.3727 18.2293 20.3326 17.6389 19.3125C17.4683 19.0181 17.4965 18.6503 17.7058 18.3814L18.2019 17.7447C18.3964 17.4953 18.4373 17.16 18.3088 16.8717L17.3309 14.6777C17.0967 14.1523 16.4198 13.9993 15.9775 14.3704C15.3288 14.9147 14.5591 15.7416 14.4657 16.6579C14.3006 18.2733 14.9992 20.3096 17.64 22.7547C20.6911 25.5798 23.1345 25.9528 24.7256 25.5706C25.628 25.3539 26.3492 24.4849 26.804 23.7732C27.1145 23.2877 26.8691 22.6434 26.3127 22.4847Z",
    fill: "#E5B910"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.e21dbedbdbae9db0680f351eb681b69f.svg";
export { ForwardRef as ReactComponent };